import { BaseButton, Button, Icon, ITextFieldProps, MessageBarType, TextField } from 'office-ui-fabric-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import Api from '../../Api';
import Auth from '../Auth';
import '../Auth.css';
import './ForgotPW.css';

export interface IForgotPWState {
  email?: string;
  success?: boolean;
  validInput: boolean;
  message?: string;
  messageType?: MessageBarType;
  isProcessing: boolean;
}

class ForgotPW extends React.PureComponent<any, IForgotPWState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isProcessing: false,
      validInput: false
    };

    this.submit = this.submit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onNotifyValidationResult = this.onNotifyValidationResult.bind(this);
  }

  public componentDidMount() {
    console.log('Origin:', document.referrer);
  }

  public render(): JSX.Element {
    return (
      <Auth
        buttonText={'Submit'}
        buttonDisabled={this.state.isProcessing || !this.state.validInput}
        buttonOnClick={this.submit}
        isProcessing={this.state.isProcessing}
        messageText={this.state.message}
        messageType={this.state.messageType}
        onKeyPress={this.onKeyPress}
      >
        <div>Forgot your password?</div>
        <div>Enter your email to reset your password.</div>
        <TextField
          className="inputField"
          type={'email'}
          placeholder="E-mail Address"
          ariaLabel="Please enter your e-mail address here"
          defaultValue={undefined}
          disabled={this.state.isProcessing}
          deferredValidationTime={50}
          validateOnLoad={false}
          onGetErrorMessage={this.getErrorMessage}
          onNotifyValidationResult={this.onNotifyValidationResult}
          // tslint:disable-next-line:jsx-no-lambda
          onChange={(ev, input) => {
            this.setState({ email: input ? input : '' });
          }}
          prefix="MailSolid"
          onRenderPrefix={this.onRenderPrefix}
        />
      </Auth>
    );
  }

  private onRenderPrefix(props: ITextFieldProps | undefined): JSX.Element {
    return props ? <Icon iconName={props.prefix} /> : <></>;
  }

  private getErrorMessage(value: string): string | undefined {
    if (!value) return 'Required';
    var regexp = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    var test = regexp.test(value);
    return !test ? 'Invalid email format' : '';
  }

  private onNotifyValidationResult(errorMessage: string | JSX.Element, value: string | undefined): void {
    this.setState({ validInput: !errorMessage });
  }

  private onKeyPress(ev: React.KeyboardEvent<HTMLDivElement | HTMLAnchorElement | HTMLButtonElement | BaseButton | Button>): void {
    if (ev.key === 'Enter' && this.state.validInput && !this.state.isProcessing) {
      this.submit();
    }
  }

  private submit(): void {
    this.setState({ isProcessing: true });

    const request = {
      email: this.state.email
    };

    Api.post('auth/forgot', request)
      .then(response => {
        const resp: string = response.data;
        console.log('Response: ', resp);
        this.setState({
          success: true,
          isProcessing: false,
          message: 'Request successfully received! If this email belongs to a valid user, an email will be sent with further instructions.',
          messageType: MessageBarType.success
        });
      })
      .catch(error => {
        console.log('error: ', error);
        console.log('error resp: ', error.response);
        const message = error.response
          ? `Request failed with status code ${error.response.status}: ${error.response.statusText}`
          : error.toJSON().message;

        this.setState({
          success: false,
          isProcessing: false,
          message: message,
          messageType: MessageBarType.error
        });
      });
  }
}

export default withRouter(ForgotPW);
